import * as React from 'react';
import { Img } from '../../components/Icons';
import './Noise.scss';

export const Noise = () => (
  <div className="Noise">
    <Img src="tapereelblack.png" />
  </div>
);
